module.exports = __webpack_public_path__ + "static/media/4.9585164f.mp3";